import React, { useState } from 'react';
import { PublicationBrowseCommon } from './../browse/PublicationBrowseCommon';
import { Header, Divider, Icon } from 'semantic-ui-react'

export function PersonPublications(props) {
	const [childRendering, setChildRendering] = useState(true);
	return (
		<>
			{childRendering &&
				<>
					<Divider horizontal inverted>
						<Header as='h4' inverted>
							<Icon name='book' />
							Publications
						</Header>
					</Divider>
					<PublicationBrowseCommon slim={true} person={props.person}
						urlParams={false} relatedRendered={(val) => setChildRendering(val)}/>
				</>
			}
		</>
	);
}